module.exports = require("assert");


//////////////////
// WEBPACK FOOTER
// external "assert"
// module id = 42
// module chunks = 0